import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { Button, CircularProgress } from '@material-ui/core';
import { DATE_END, DATE_INIT } from '../../../app/api-client/constants';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(5, 15, 5),

  },

}));

export default function BasicDateRangePicker({ handlerFilter, isLoading, isDate, titlePanel = 'Datos De Isla' }) {

  let init_date = localStorage.getItem(DATE_INIT );
  let end_date = localStorage.getItem(DATE_END + 1);
  const [dataStart, setDataStart] = useState();
  const [dataEnd, setDataEnd] = useState();
  const classes = useStyles();

  const handleDateChange = (date) => {
    setDataStart(date);
  };

  const handleDateEnd = (date) => {
    setDataEnd(date);
  };

  const handerSendFilter = () => {

    handlerFilter(dataStart, dataEnd)
  }

  const initDates = () => {
    if (!isDate) {
      let end = new Date(); // Fecha actual
      let init = new Date(end.getFullYear(), end.getMonth() - 1, end.getDate()); // Un mes antes de la fecha actual

      handlerFilter(init, end);
      setDataStart(init);
      setDataEnd(end);
    } else {
      let init = new Date(init_date);
      init = init.getTime();
  
      let end = new Date(end_date);
      end = end.getTime() - 86400000; // Restar un día de la fecha final
      setDataStart(new Date(init));
      setDataEnd(new Date(end));
    }
  }
  

  useEffect(() => {
    initDates();

  }, [])

  const customDatePickerMonthNavIcons = makeStyles((theme) => ({
    root: {
      '& .MuiSvgIcon-root': {
        fill: theme.palette.primary.main, // Cambia el color de los iconos de navegación de meses a primary
      },
    },
  }));

  return (
    <>
      <Typography align="center" variant="h4" style={{ fontSize: "35pt", fontFamily: "'Segoe UI Variable Static Display 700', sans-serif" }} color='primary'>{titlePanel}</Typography>

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} md={4}>
            <KeyboardDatePicker
              type='textdate'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              margin="normal"
              id="date-picker-inline"
              label="Fecha inicial"
              value={dataStart}
              style={{ textTransform: "none", width: "78%", marginLeft: "52%" }}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={customDatePickerMonthNavIcons().root} 
            />
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <KeyboardDatePicker
              type='textdate'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              minDate={dataStart}
              margin="normal"
              id="date-picker-inline"
              label="Fecha Final "
              value={dataEnd}
              style={{ textTransform: "none", width: "78%", marginLeft: "49%" }}
              onChange={handleDateEnd}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={customDatePickerMonthNavIcons().root} 


            />
          </Grid>
          <Grid item xs={12} sm={4} md={4} style={{ marginTop: '1%' }}>
            <div className={classes.wrapper}>
              {/* <Grid container justify="center" style={{ marginTop: '10px' }}> */}
              <Button
                disabled={isLoading}
                type="submit"
                variant="contained"
                color="primary"
                onClick={handerSendFilter}
                style={{ textTransform: "none", width: "25%", borderRadius: '8px', height: '31px', marginTop: '5%', marginLeft: '36%' }}
              >
                Filtrar
              </Button>
              {/* </Grid> */}
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </>
  );
}
